export const DATABASE_CONTENT_TYPE = 'database';

export const DEFAULT_VIEW_NAME = 'View 1';

/** Columns in table view mode cannot be resized to anything more narrow than this */
export const TABLE_VIEW_HARD_COLUMN_MIN_WIDTH = 85;
/** Columns in table view mode with undefined width will have this minimum width applied */
export const TABLE_VIEW_SOFT_COLUMN_MIN_WIDTH = 200;

/** Number of times that a database value may reference another database value before breaking the recursion */
export const RECURSION_LIMIT = 10;

export const NUMBERED_COLUMN_WIDTH = 50;

export const TABLE_VIEW_COLUMN_WIDTH_COMMENTS_BUFFER = 30;

export const CONFLUENCE_SUPPORT_URL =
  'https://support.atlassian.com/confluence-cloud/docs/create-and-edit-databases/';

export const TABLE_CLASSNAMES = {
  IS_SELECTED: 'isSelected',
  IS_SOFT_SELECTED: 'isSoftSelected',
  IS_INVALID: 'isInvalid',
  SHOW_AS_DRAGGING: 'showAsDragging',
  SHOW_AS_DISABLED: 'showAsDisabled',
  IS_SKELETON_ENABLED: 'isSkeletonEnabled',
  IS_TOP_ADJACENT_SELECTED: 'isTopAdjacentSelected',
  IS_BOTTOM_ADJACENT_SELECTED: 'isBottomAdjacentSelected',
  IS_LEFT_ADJACENT_SELECTED: 'isLeftAdjacentSelected',
  IS_RIGHT_ADJACENT_SELECTED: 'isRightAdjacentSelected',
  IS_HOVER_DELETE_BUTTON: 'isHoverDeleteButton',
  HIDE_BORDER_ON_FOCUS: 'hideBorderOnFocus',
  MAXIMIZE_HEIGHT: 'maximizeHeight',
  SELECT_BUTTON: 'selectButton',
  ACTIVE_DRAG_HANDLER_ICON: 'activeDragHandlerIcon',
  DRAG_HANDLER_ICON: 'dragHandlerIcon',
  ACTIONS: 'actions',
  ADD_FIELD: 'addField',
  INSERT_COLUMN_BEFORE: 'insertColumnBefore',
  INSERT_COLUMN_AFTER: 'insertColumnAfter',
} as const;
